
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoahmednagarcab() {



    const cardData =
    {
        keyword: 'Pune to Ahmednagar Cab',
        heading: 'Meghana Cab : Pune to Ahmednagar Cab',
        headingDescription: 'Meghana Cab offers Pune to Ahmednagar Cab services, providing a comfortable and reliable travel option between Pune and Ahmednagar. Whether you are traveling for business, educational visits, pilgrimage, or a family trip, our clean, well-maintained cabs and experienced drivers ensure a smooth and safe journey. Choose from a variety of vehicles to suit your group size and preferences, and enjoy transparent pricing, punctual pickups, and 24/7 customer support. Book your Pune to Ahmednagar Cab with Meghana Cab and experience a hassle-free, comfortable ride every time.',


        top: 'Top Places to Visit in Ahmednagar with Meghana Cab',

"topPlaces": [
  {
    "title": "Ahmednagar Fort",
    "description": "A formidable 16th-century stronghold built by Malik Ahmad Nizam Shah I, later expanded under Hussain Nizam Shah. With its 24 bastions, deep moat, and robust ramparts, this basalt-granite fort was central to the Nizam Shahi dynasty and witnessed sieges by Mughals under Akbar and later used by the British as a prison holding Nehru and other freedom fighters during the Quit India Movement."
  },
  {
    "title": "Cavalry Tank Museum",
    "description": "Asia’s first and only cavalry tank museum, established in 1994 by the Armoured Corps Centre & School. The open-air museum houses around 50 tanks and armoured vehicles—from World War I/Vintage British Valentine tanks and Japanese Ha-Go to captured Patton tanks from the 1965 and 1971 wars—offering insights into the evolution of armoured warfare."
  },
  {
    "title": "Tomb of Salabat Khan II (Chand Bibi's Tomb)",
    "description": "Also known as Chand Bibi’s Mahal, the 16th-century Mughal-style mausoleum sits atop a hill offering peaceful vistas of Ahmednagar city. Built for Salabat Khan II, the octagonal structure showcases classical features like open-air verandahs, ornate domes, and serene gardens."
  },
  {
    "title": "Farah Bagh (Faria Bagh Palace)",
    "description": "Constructed in 1583 by the Nizam Shahi rulers, this Indo-Islamic pleasure palace once featured an octagonal central tower surrounded by lotus-shaped ponds and lush gardens. Though now mostly in ruins, its remains reflect the grandeur of the Sultanate period and its cooling garden design."
  },
  {
    "title": "Meherabad & Meherazad",
    "description": "The spiritual retreat and samadhi of Meher Baba, located a few kilometres from Ahmednagar. Established around Adam Baba’s tomb, it has tranquil ashram premises, meditation halls, and pilgrimage pathways. Visitors often stay overnight for communal prayers and spiritual reflection."
  },
  {
    "title": "Rehekuri Blackbuck Sanctuary",
    "description": "Spread over approximately 5.29 km², this protected area is home to blackbucks, chinkaras, spotted deer, boars, wolves and over 160 species of birds. Located 25 km from Ahmednagar, it offers guided wildlife safaris and photographic opportunities in a dry grassland ecosystem."
  },
  {
    "title": "Shani Shingnapur",
    "description": "A renowned pilgrim village about 70 km from Ahmednagar, famous for its open-air Shani temple dedicated to the deity Saturn. Known for the unique practice where doors and locks are absent from homes—reflecting the community’s faith in divine protection—this site draws devotees year-round."
  },
  {
    "title": "Amruteshwar Temple",
    "description": "A 9th-century Hemadpanti-style Shiva temple in Ratanwadi village, noted for its intricate stone carvings, stepped tank (pushkarani), and Nandi mandapa. The pristine temple, declared a monument of national importance, exemplifies early medieval Deccan architecture."
  },
  {
    "title": "Harishchandragad Fort",
    "description": "A hill-fort rising to 1,422 m in the Western Ghats, featuring the iconic Konkan Kada cliff, ancient caves, temples, and the Saptatirtha Pushkarni tank. Believed to date to the Kalachuri era, it’s favored by trekkers for its rocky escarpments and panoramic vistas."
  },
  {
    "title": "Daulatabad Fort (Deogiri)",
    "description": "A monumental 12th-century fortress near Aurangabad once secondary capital of the Chalukyas and Ahmadnagar Sultanate. Known for its elaborate defense features—inclined passages, complex gates, the massive Chand Minar—and strategic vertical design atop a 200 m conical hill."
  }
],

    "services": [
    {
      "name": "Outstation Cab Booking from Pune",
      "description": "Book reliable and comfortable outstation cabs from Pune with Meghana Cab. Whether you're planning a short getaway or a long-distance trip, we offer well-maintained vehicles, professional drivers, and flexible packages for every travel need."
    },
    {
      "name": "One Way Outstation Cab Pune",
      "description": "Need a drop-off in another city? Book a one-way outstation cab from Pune and save on travel costs. Meghana Cab offers a wide fleet of vehicles with timely pickup and convenient booking options for one-way trips."
    },
    {
      "name": "Round Trip Outstation Cabs Pune",
      "description": "Choose our round trip outstation cab services from Pune for a complete travel solution. Ideal for weekend getaways, business meetings, or family trips, our round trip packages are flexible, cost-effective, and come with reliable support."
    },
    {
      "name": "Sedan Outstation Cabs from Pune",
      "description": "For comfortable and budget-friendly travel, book our sedan cabs for outstation journeys from Pune. Ideal for small families or solo travelers, our sedans offer AC comfort and clean interiors for a relaxed ride."
    },
    {
      "name": "SUV Rental for Outstation Pune",
      "description": "Planning a group or family outing? Our spacious SUVs are perfect for outstation travel from Pune. Enjoy ample legroom, luggage space, and a powerful ride for long highway journeys with Meghana Cab."
    },
    {
      "name": "Affordable Outstation Travel from Pune",
      "description": "Meghana Cab provides affordable outstation travel options from Pune without compromising on service quality. Get the best prices, well-maintained vehicles, and courteous drivers for your journey."
    },
    {
      "name": "Online Outstation Booking Pune",
      "description": "Enjoy the convenience of online outstation cab booking from Pune with Meghana Cab. Select your destination, vehicle type, and schedule—all within minutes. Safe, easy, and fully digital process."
    },
    {
      "name": "24/7 Outstation Taxi Service Pune",
      "description": "Travel at any time with our 24/7 outstation taxi service from Pune. Whether it’s an early morning pickup or a late-night drop, Meghana Cab is available round-the-clock for all your intercity travel needs."
    }
  ],
  "tableData": [
    ["Outstation Cab Booking from Pune", "One Way Outstation Cab Pune"],
    ["Round Trip Outstation Cabs Pune", "Sedan Outstation Cabs from Pune"],
    ["SUV Rental for Outstation Pune", "Affordable Outstation Travel from Pune"],
    ["Online Outstation Booking Pune", "24/7 Outstation Taxi Service Pune"]
  ],









"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Ahmednagar Cab Service",
        "WhyChoosedescription": "Meghana Cab offers safe, punctual, and comfortable cabs from Pune to Ahmednagar, suitable for business trips, family visits, or temple tours. Our service ensures a smooth 2.5 to 3-hour journey across well-maintained highways with courteous and experienced drivers."
    },
    {
        "WhyChooseheading": "Affordable and Fixed Fare Options",
        "WhyChoosedescription": "We provide budget-friendly Pune to Ahmednagar cab fares with transparent pricing. The fare includes fuel, driver allowance, and taxes—no hidden charges or last-minute surprises. Choose the cab that suits your needs and budget."
    },
    {
        "WhyChooseheading": "Variety of Cabs for Every Traveller",
        "WhyChoosedescription": "Travel solo or in a group—Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers. Each vehicle is air-conditioned, sanitized, and spacious for a relaxed highway ride from Pune to Ahmednagar."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
        "WhyChoosedescription": "Our drivers are trained, polite, and familiar with the Pune–Ahmednagar route. They ensure timely pickup, safe driving through the highway stretch, and optional halts for refreshments or rest."
    },
    {
        "WhyChooseheading": "Flexible One-Way and Round Trip Services",
        "WhyChoosedescription": "Meghana Cab offers both one-way drops and round-trip packages to Ahmednagar. Whether it’s a same-day return or an extended visit, we accommodate your schedule with ease."
    },
    {
        "WhyChooseheading": "24/7 Availability for Any Time Travel",
        "WhyChoosedescription": "We operate 24/7, making it easy to book an early morning or late-night cab from Pune to Ahmednagar. Our dedicated support team is always ready to assist you with bookings or modifications."
    },
    {
        "WhyChooseheading": "Easy Booking with Live Cab Tracking",
        "WhyChoosedescription": "Book your ride in minutes via our website, app, or customer care. Get instant confirmation, driver details, and live location tracking to stay informed throughout your journey."
    },
    {
        "WhyChooseheading": "Ideal for Personal, Pilgrimage, and Corporate Travel",
        "WhyChoosedescription": "Whether you're heading to Shirdi via Ahmednagar, visiting family, or traveling for business, Meghana Cab ensures reliable, comfortable, and timely transportation for every purpose."
    }
]












































    }

const faqData = [
    {
        question: "How can I book a cab from Pune to Ahmednagar with Meghana Cab?",
        answer: "You can easily book a Pune to Ahmednagar cab by calling Meghana Cab at +91 9075462128 or through our website."
    },
    {
        question: "What types of vehicles are available for Pune to Ahmednagar trips?",
        answer: "We offer sedans, SUVs, and tempo travellers depending on your group size and comfort needs."
    },
    {
        question: "Are Meghana Cab drivers familiar with the Pune to Ahmednagar route?",
        answer: "Yes, our drivers know the best routes to ensure a safe and timely journey to Ahmednagar."
    },
    {
        question: "Can I book a one-way or round-trip cab from Pune to Ahmednagar?",
        answer: "Yes, both one-way and round-trip services are available."
    },
    {
        question: "What is included in the Pune to Ahmednagar cab fare?",
        answer: "The fare includes driver charges, fuel, tolls, and vehicle maintenance. Additional charges may apply based on your trip."
    },
    {
        question: "Are Meghana Cab vehicles sanitized for Pune to Ahmednagar trips?",
        answer: "Yes, all vehicles are regularly cleaned and sanitized for your safety and comfort."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Ahmednagar bookings?",
        answer: "Yes, our services operate round-the-clock to accommodate your travel plans."
    },
    {
        question: "Can I request special requirements like child seats for Pune to Ahmednagar trips?",
        answer: "Yes, special requests can be made during booking."
    },
    {
        question: "What payment methods are accepted for Pune to Ahmednagar cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Ahmednagar cab services?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune to Ahmednagar cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Prakash Shinde',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune to Ahmednagar cab service by Meghana Cab was comfortable and punctual.”',
    },
    {
        name: 'Ms. Neha Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly recommend Meghana Cab for trips to Ahmednagar. Friendly driver and clean vehicle.”',
    },
];








































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const ahmednagarCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Ahmednagar Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-ahmednagar-cab.jpg",
  "description": "Book affordable and reliable Pune to Ahmednagar cab services with Meghana Cabs. One way and round trip taxi options, AC sedans, SUVs, and family travel cabs available.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "One Way Cab Pune to Ahmednagar",
    "Round Trip Taxi Pune to Ahmednagar",
    "AC Sedan Hire",
    "SUV Rental",
    "Family Taxi Service"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pune to Ahmednagar Cab Offers",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Cab Pune to Ahmednagar"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Taxi Pune to Ahmednagar"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "SUV Rental Pune to Ahmednagar"
        }
      }
    ]
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Ahmednagar Cab | Meghana Cabs</title>
  <meta
    name="description"
    content="Book affordable and reliable Pune to Ahmednagar cab services with Meghana Cabs. One way and round trip taxi options, AC sedans, SUVs, and family travel cabs available."
  />
  <meta
    name="keywords"
    content="Cab Booking Pune to Ahmednagar, One Way Cab to Ahmednagar from Pune, Round Trip Taxi Pune to Ahmednagar, AC Sedan Pune to Ahmednagar Trip, Affordable Ahmednagar Taxi Pune, Online Taxi Booking Pune to Ahmednagar, SUV Rental Pune to Ahmednagar, City to City Cab Pune to Ahmednagar, Pune to Ahmednagar Distance by Taxi, Fast Cab Service Pune to Ahmednagar, Budget Taxi Hire Pune to Ahmednagar, Private Car Pune to Ahmednagar, Driver Service Pune to Ahmednagar Cab, Family Taxi Pune to Ahmednagar, Outstation Cab Pune to Ahmednagar"
  />
  <script type="application/ld+json">
    {JSON.stringify(ahmednagarCabSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/40.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoahmednagarcab;